<template>
	<v-container grid-list-md class="container--box">
		<v-card>
			<v-card-title primary-title>
				{{ item.membership_name }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<v-img
							:src="item.image_url"
							style="max-height: 250px"
							contain
						></v-img>
					</v-flex>
					<v-flex xs12 md6>
						<v-subheader class="pa-0 ma-0">
							<strong>{{ $t("label.starts_at") }}</strong>
						</v-subheader>
						<p>{{ item.starts_at }}</p>
					</v-flex>
					<v-flex xs12 md6>
						<v-subheader class="pa-0 ma-0">
							<strong>{{ $t("label.ends_at") }}</strong>
						</v-subheader>
						<p>{{ item.ends_at }}</p>
					</v-flex>
					<v-flex xs12>
						<v-subheader class="pa-0 ma-0">
							<strong>{{ $t("label.vouchers") }}</strong>
						</v-subheader>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">
											{{ $t("Name") }}
										</th>
										<th class="text-left">
											{{ $t("Discount") }}
										</th>
										<th class="text-left">
											{{ $t("label.usage") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											voucher, index
										) in item.vouchers"
										:key="index"
									>
										<td>{{ voucher.name }}</td>
										<td>
											{{ voucher.discount }}
										</td>
										<td>
											{{ voucher.resettable }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["data"],
	data() {
		return {
			item: this.data,
		};
	},
};
</script>